import React, { createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { useRealtime } from "./useRealtime";
import NotificationBell from "./NotificationBell";

/* RealtimeProvider — one WebSocket connection + notification state for a whole
 * workspace. Exposes the realtime bundle via context (so any page can read
 * lastEvent to live-refresh its lists) and renders a floating notification bell
 * in the top-right corner across every page. */

const RealtimeContext = createContext(null);
export function useRealtimeCtx() { return useContext(RealtimeContext); }

export default function RealtimeProvider({ children, bell = true }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const rt = useRealtime(user);

  const openNotification = (n) => {
    // sales orders live on the client Orders tab; jump there when we know the client
    if (n && n.entity_id) nav("/store/clients");
  };

  return (
    <RealtimeContext.Provider value={rt}>
      {bell && user && (
        <div style={{ position: "fixed", top: 12, right: 16, zIndex: 8000,
          background: "var(--bg-surface,#fff)", borderRadius: 10, boxShadow: "0 4px 14px rgba(0,0,0,0.12)" }}>
          <NotificationBell
            notifications={rt.notifications} unread={rt.unread} connected={rt.connected}
            onMarkRead={rt.markRead} onMarkAllRead={rt.markAllRead} onOpen={openNotification} />
        </div>
      )}
      {children}
    </RealtimeContext.Provider>
  );
}
